import axios from "axios";


const NGROK_URL =
  "https://657c-2c0f-ef58-1621-5000-fd98-bbf9-67f7-1685.ngrok-free.app/";
const API_URL = "http://vps-1bb3c680.vps.ovh.net:9700/";
const JSON_URL = "https://api-contribuable.onrender.com/";
const EXPRESS_URL = "http://localhost:4000/";

let url = JSON_URL;

const api = axios.create({
  baseURL: url, // continuous deployement 12 mai
});

api.interceptors.request.use((req) => {
  req.headers["ngrok-skip-browser-warning"] = true;
  const token = JSON.parse(sessionStorage.getItem("utilisateurs"));
  // Add Authorization header with the Bearer token to the request
  if (token) {
    req.headers["Authorization"] = "Bearer " + token.accessToken;
  }
  return req;
});






export { api, url };
